import SendActivationEmail from './SendActivationEmail'

export default SendActivationEmail;
